<template>
	<span class="has-bbox-tooltip" :style="`--bg-color: var(--${backgroundColor})`">
		<span
			@mouseover="showTooltip = true"
			@click="showTooltip = !showTooltip"
			style="cursor: pointer"
			@mouseleave="showTooltip = false"
		>
			<slot />
		</span>
		<transition name="fade" @enter="enterTransition">
			<div
				class="bbox-tooltip"
				:class="[position, { 'banner': banner }]"
				v-if="showTooltip"
				@mouseover="showTooltip = false"
			>
				<div
					v-if="!banner && (!!title || !!$slots.title)"
					class="bbox-tooltip-default padding-vertical-tiny padding-horizontal-normal white-base font-size-tiny semi-bold"
				>
					<template v-if="!!title && !$slots.title">{{ title }}</template>
					<slot name="title"></slot>
				</div>
				<div v-if="banner" class="bbox-tooltip-banner padding-vertical-tiny padding-horizontal-normal white-base">
					<slot name="banner" />
				</div>
			</div>
		</transition>
	</span>
</template>

<script>
export default {
	name: 'bbox-tooltip',
	components: {},
	props: {
		title: String,
		text: String,
		banner: Boolean,
		position: {
			type: String,
			default: 'top'
		},
		color: {
			type: String,
			default: 'white-base'
		},
		backgroundColor: {
			type: String,
			default: 'ink-lighter-1'
		}
	},
	methods: {
		enterTransition: function(el) {
			var windowOffsetLeft = el.children[0].getBoundingClientRect().left;
			var windowOffsetRight = el.children[0].getBoundingClientRect().right;
			var trans = { X: '-50%', Y: '-100%' };
			if (this.position === 'bottom') {
				trans.X = '-50%';
				trans.Y = '0';
			}
			if (windowOffsetLeft < 16) {
				if (this.position === 'left') {
					this.position = 'top';
					el.classList.remove('left');
					el.classList.add('top');
					this.enterTransition(el);
					return;
				}
				var realOffsetLeft = 16 - windowOffsetLeft;
				trans.X = 'calc(' + trans.X + ' + ' + realOffsetLeft + 'px)';
				el.style.transform = 'translate(' + trans.X + ', ' + trans.Y + ')';
			} else if (windowOffsetRight < 16) {
				if (this.position === 'right') {
					this.position = 'top';
					el.classList.remove('right');
					el.classList.add('top');
					this.enterTransition(el);
					return;
				}
				var realOffsetRight = 16 - windowOffsetRight;
				trans.X = 'calc(' + trans.X + ' - ' + realOffsetRight + 'px)';
				el.style.transform = 'translate(' + trans.X + ', ' + trans.Y + ')';
			}
		}
	},
	data() {
		return {
			showTooltip: false
		};
	}
};
</script>

<style lang="scss" scoped>
.has-bbox-tooltip {
	position: relative;
	display: inline-block;
}

.bbox-tooltip {
	position: absolute;
	z-index: 10;
	width: 100vw;
	display: flex;
	justify-content: center;
	align-content: center;
	justify-items: center;
	align-items: center;
}
.bbox-tooltip.top {
	top: calc((0.8rem + 0.98rem) * -1);
	left: 50%;
	transform: translate(-50%, -100%);
}
.bbox-tooltip.top::after {
  content: " ";
  position: absolute;
  top: 95%;
  left: 50%;
  margin-left: -1rem;
  border-width: 1rem;
  border-style: solid;
  border-color: var(--bg-color) transparent transparent transparent;
}
.bbox-tooltip.right {
	top: 50%;
	left: calc(100% + 0.8rem + 0.98rem);
	transform: translate(0%, -50%);
	justify-content: flex-start;
	justify-items: flex-start;
}
.bbox-tooltip.right::after {
  content: " ";
  position: absolute;
  top: 50%;
  right: 100%;
  margin-top: -1rem;
  border-width: 1rem;
  border-style: solid;
  border-color: transparent var(--bg-color) transparent transparent;
}
.bbox-tooltip.bottom {
	top: calc(100% + 0.8rem + 0.98rem);
	left: 50%;
	transform: translate(-50%, 0);
}
.bbox-tooltip.bottom::after {
  content: " ";
  position: absolute;
  bottom: 98%;
  left: 50%;
  margin-left: -1rem;
  border-width: 1rem;
  border-style: solid;
  border-color:  transparent transparent var(--bg-color) transparent;
}
.bbox-tooltip.left {
	top: 50%;
	left: calc((0.98rem + 0.8rem) * -1);
	transform: translate(-100%, -50%);
	justify-content: flex-end;
	justify-items: flex-end;
}
.bbox-tooltip.left::after {
  content: " ";
  position: absolute;
  top: 50%;
  left: 100%;
  margin-top: -1rem;
  border-width: 1rem;
  border-style: solid;
  border-color: transparent transparent transparent var(--bg-color);
}

.bbox-tooltip.top.banner::after {
  top: 99%;
}
.bbox-tooltip.bottom.banner::after {
  bottom: 99%;
}

.bbox-tooltip-banner {
	max-width: 27rem;
	background-color: var(--bg-color);
	border-radius: 5px;
	box-shadow: none;
}
.bbox-tooltip-default {
	background-color: var(--bg-color);
	border-radius: 5px;
	max-width: 27rem;
	box-shadow: none;
}
.bbox-tooltip-default > * {
	color: #fff;
	line-height: 1.3333;
	letter-spacing: 0.02em;
	font-size: 1rem;
	margin: 0;
}
</style>
